<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6uUFNP/tc-custom/9781626816138.jpg?1734326751877" alt="This image is the cover for the book Kirby's Last Circus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kirby's Last Circus
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of the Chance Purdue series introduces a Chicago detective who goes under the big top to take down the ringmaster of a Russian conspiracy.</b><br/>  <br/> When the CIA chooses Birch Kirby, a mediocre detective with a personal life even less thrilling than his professional one, no one is more surprised by the selection than Birch himself. But the agency needs someone for a secret mission, and Birch may be just the clown for the job. Going undercover as a circus performer, he travels to Grizzly Gulch to investigate the source of daily, un-decodable secret messages that are being transmitted to the KGB. Birch interacts with wildly colorful characters while stumbling through performances as well as his assignment. With the clock ticking, Birch must hurry to take a right step toward bringing the curtain down on this very important case.<br/>  <br/><b>Praise for Ross H. Spencer’s <i>The Dada Caper</i></b><br/> “Parodies of the private‐eye novel come and go. Here is <i>The Dada Caper</i> by Ross H. Spencer. It has every cliché down pat, including rat-tat-tat writing in which paragraphs are seldom more than one sentence. . . . The hero is a private eye who is always tailing the wrong people and hitting the wrong guys. <i>The Dada Caper</i> is wild, shrewd, mad and unexpectedly funny.” —<i>The New York Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ross H. Spencer
      </h2>
      
      <p class="authorDescription body article">Ross H. Spencer (1921–1998) was a mystery author, best known for his series of comic novels that astutely satirized the private eye genre.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bd53c2ea